import React, { createContext, useContext, useState, useEffect } from 'react';

const PharmacyContext = createContext();

export function PharmacyProvider({ children }) {
  const [userPharmacies, setUserPharmacies] = useState([]);
  const [selectedPharmacyIds, setSelectedPharmacyIds] = useState(['all']);
  const [currentUser, setCurrentUser] = useState(null);

  useEffect(() => {
    // Load user and pharmacies from localStorage
    const user = JSON.parse(sessionStorage.getItem('pharmacy_user') || localStorage.getItem('pharmacy_user') || '{}');
    setCurrentUser(user);
    
    if (user.pharmacies && user.pharmacies.length > 0) {
      setUserPharmacies(user.pharmacies);
      // Par défaut, sélectionner toutes les pharmacies
      setSelectedPharmacyIds(['all']);
    }
  }, []);

  const updateUserPharmacies = (pharmacies) => {
    setUserPharmacies(pharmacies);
    if (pharmacies.length > 0) {
      setSelectedPharmacyIds(['all']);
    }
  };

  const togglePharmacy = (pharmacyId) => {
    if (pharmacyId === 'all') {
      setSelectedPharmacyIds(['all']);
    } else {
      setSelectedPharmacyIds(prev => {
        // Remove 'all' if it was selected
        const filtered = prev.filter(id => id !== 'all');
        
        if (filtered.includes(pharmacyId)) {
          // Deselect
          const newSelection = filtered.filter(id => id !== pharmacyId);
          return newSelection.length === 0 ? ['all'] : newSelection;
        } else {
          // Select
          const newSelection = [...filtered, pharmacyId];
          // If all pharmacies are selected, switch to 'all'
          if (newSelection.length === userPharmacies.length) {
            return ['all'];
          }
          return newSelection;
        }
      });
    }
  };

  const getPharmacyIdsParam = () => {
    if (selectedPharmacyIds.includes('all')) {
      return 'all';
    }
    return selectedPharmacyIds.join(',');
  };

  const getSelectedPharmaciesNames = () => {
    if (selectedPharmacyIds.includes('all')) {
      return 'Toutes mes pharmacies';
    }
    return userPharmacies
      .filter(p => selectedPharmacyIds.includes(p.pharmacy_id))
      .map(p => p.pharmacy_name)
      .join(', ');
  };

  return (
    <PharmacyContext.Provider value={{
      userPharmacies,
      selectedPharmacyIds,
      currentUser,
      updateUserPharmacies,
      togglePharmacy,
      setSelectedPharmacyIds,
      getPharmacyIdsParam,
      getSelectedPharmaciesNames
    }}>
      {children}
    </PharmacyContext.Provider>
  );
}

export function usePharmacies() {
  const context = useContext(PharmacyContext);
  if (!context) {
    throw new Error('usePharmacies must be used within a PharmacyProvider');
  }
  return context;
}
